import React, { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Crown, Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

export default function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const subscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Merci ! Vous êtes inscrite à notre lettre.");
      setEmail("");
    } catch {
      toast.error("Impossible de vous inscrire pour le moment.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#2C1E23] text-[#FAF7F2] pt-20 pb-10"
    >
      <div className="max-w-[1400px] mx-auto px-6 grid lg:grid-cols-12 gap-12 border-b border-[#FAF7F2]/10 pb-14">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 border border-[#C5A059] flex items-center justify-center">
              <Crown className="w-5 h-5 text-[#C5A059]" />
            </span>
            <div>
              <div className="font-serif-display text-xl">
                Le Sanctuaire des Mères
              </div>
              <div className="text-[0.62rem] tracking-[0.32em] uppercase text-[#C5A059]">
                Association Les Mamans Reines
              </div>
            </div>
          </div>
          <p className="mt-6 text-[#FAF7F2]/70 max-w-md leading-relaxed">
            Le premier sanctuaire urbain parisien pour les mères victimes de
            violences conjugales. Un refuge, une transmission, une renaissance.
          </p>

          <form
            onSubmit={subscribe}
            data-testid="newsletter-form"
            className="mt-10 flex flex-col sm:flex-row gap-3 max-w-md"
          >
            <input
              type="email"
              data-testid="newsletter-email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Votre email"
              required
              className="flex-1 bg-transparent border border-[#FAF7F2]/20 text-[#FAF7F2] px-4 py-3 text-sm placeholder:text-[#FAF7F2]/40 focus:border-[#C5A059] outline-none transition-colors"
            />
            <button
              type="submit"
              disabled={loading}
              data-testid="newsletter-submit-button"
              className="sdm-btn-gold disabled:opacity-60"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "S'inscrire"}
            </button>
          </form>
        </div>

        <div className="lg:col-span-3">
          <div className="text-[0.68rem] tracking-[0.22em] uppercase text-[#C5A059] font-medium mb-4">
            Navigation
          </div>
          <ul className="space-y-2">
            {[
              { label: "Notre Vision", href: "#vision" },
              { label: "Rituel de Renaissance", href: "#rituel" },
              { label: "Ateliers", href: "#ateliers" },
              { label: "Incubateur", href: "#incubateur" },
              { label: "Les Espaces", href: "#espaces" },
              { label: "Galerie", href: "#galerie" },
              { label: "Application mobile", href: "#application" },
              { label: "Faire un don", href: "#don" },
              { label: "Contact", href: "#contact" },
            ].map((n) => (
              <li key={n.href}>
                <a
                  href={n.href}
                  className="text-[#FAF7F2]/75 hover:text-[#C5A059] sdm-link-underline text-sm"
                >
                  {n.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-4">
          <div className="text-[0.68rem] tracking-[0.22em] uppercase text-[#C5A059] font-medium mb-4">
            Coordonnées
          </div>
          <div className="space-y-2 text-sm text-[#FAF7F2]/80">
            <div>Association Les Mamans Reines</div>
            <div>54 rue Jean-Baptiste Pigalle</div>
            <div>75009 Paris, France</div>
            <div className="pt-3">
              <span className="text-[0.65rem] tracking-[0.22em] uppercase text-[#C5A059]">
                N° RNA
              </span>{" "}
              W751 258 627
            </div>
            <div>
              <a
                href="mailto:lesmamansreines@gmail.com"
                className="sdm-link-underline"
              >
                lesmamansreines@gmail.com
              </a>
            </div>
            <div>
              <a
                href="tel:+33620658089"
                className="sdm-link-underline"
              >
                06 20 65 80 89
              </a>
            </div>
          </div>

          <div className="mt-8 p-4 border border-[#C5A059]/40">
            <div className="text-[0.65rem] tracking-[0.22em] uppercase text-[#C5A059] mb-1">
              Urgence — 24h/24
            </div>
            <div className="font-serif-display text-2xl text-[#FAF7F2]">
              3919 · anonyme & gratuit
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 mt-8 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-[#FAF7F2]/60">
        <span>
          © {new Date().getFullYear()} Association Les Mamans Reines — Tous droits réservés.
        </span>
        <span className="font-serif-display italic text-[#C5A059]">
          « Que chaque mère redevienne une Reine. »
        </span>
      </div>
    </footer>
  );
}
